import { render, staticRenderFns } from "./GuFengPingWarning.vue?vue&type=template&id=01309168&scoped=true&"
import script from "./GuFengPingWarning.vue?vue&type=script&lang=js&"
export * from "./GuFengPingWarning.vue?vue&type=script&lang=js&"
import style0 from "./GuFengPingWarning.vue?vue&type=style&index=0&id=01309168&prod&lang=scss&scoped=true&"
import style1 from "./GuFengPingWarning.vue?vue&type=style&index=1&id=01309168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01309168",
  null
  
)

export default component.exports